import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline group"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-vip-crown-line text-background-50 text-lg"></i>
            </span>
            <span className="text-lg font-heading font-bold whitespace-nowrap">
              国产一区
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 rounded-lg text-sm transition-colors ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 rounded-lg text-sm transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm transition-colors ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}